/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useRef, useEffect} from 'react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import clsx from 'clsx'
import {getAllCountries, verifyPhoneNumber, GetAppNameByName} from '../core/_requests'
import {useSearchParams} from 'react-router-dom'
import {PasswordMeterComponent} from '../../../../_metronic/assets/ts/components'
import {useAuth} from '../core/Auth'
import {ReactElement} from 'react'
import Select from 'react-select'
import {useNavigate} from 'react-router-dom'
import {convertNumbersToEnglish, onlyDigits} from '../../global/components/InputHandler'
import {useTranslation} from 'react-i18next'

const initialValues = {
  phoneNumber: '',
  countryCode: '',
  countryId: 0,
}

export function VerifyPhoneNumber() {
  const {t, i18n} = useTranslation()

  const [loading, setLoading] = useState(false)
  const {saveAuth, currentUser} = useAuth()
  type TypeCountries = {
    value: string
    label: string | ReactElement
    name: string
    icon: string
    code: string
    regex: number
  }

  const [countries, setCountries] = useState<TypeCountries[]>([])
  const [countryId, setCountryId] = useState(0)
  const [countryCode, setCountryCode] = useState('')
  const [countryPhoneRegex, setCountryPhoneRegex] = useState(0)
  const [selectedOption, setSelectedOption] = useState(countries[0])
  const [errorMessage, setErrorMessage] = useState('')
  const [showErrorMessage, setShowErrorMessage] = useState(false)
  const [warningMessage, setWarningMessage] = useState('')
  const [showWarningMessage, setShowWarningMessage] = useState(false)
  const [codeMemory, setCodeMemory] = useState('')
  const phoneNumberRef = useRef<HTMLInputElement>(null)
  const [searchParams] = useSearchParams()

  const findCodeInQuery = () => {
    const code = searchParams.get('code')
    if (code) {
      setCodeMemory(code)
    }
  }
  useEffect(() => {
    findCodeInQuery()
  }, [codeMemory])

  const customFilter = (option, searchText) => {
    if (
      option.data.name.toLowerCase().includes(searchText.toLowerCase()) ||
      option.data.code.toLowerCase().includes(searchText.toLowerCase())
    ) {
      return true
    } else {
      return false
    }
  }

  const registrationSchema = Yup.object().shape({
    phoneNumber: Yup.string()
      .min(
        countryPhoneRegex,
        countryId == 0
          ? t('AUTH.VERIFY.SELECT_COUNTRY_ERROR')
          : t('AUTH.VERIFY.PHONE_LENGTH_ERROR', {count: countryPhoneRegex})
      )
      .max(
        countryPhoneRegex,
        countryId == 0
          ? t('AUTH.VERIFY.SELECT_COUNTRY_ERROR')
          : t('AUTH.VERIFY.PHONE_LENGTH_ERROR', {count: countryPhoneRegex})
      )
      .required(t('AUTH.VERIFY.PHONE_REQUIRED')),
  })

  const changeCountryHandler = (event) => {
    setCountryCode(event.code)
    setCountryId(event.value)
    setCountryPhoneRegex(event.regex)
    setSelectedOption(event)
    formik.setFieldValue('countryId', event.value)
    phoneNumberRef.current?.focus()
  }

  const isMounted = useRef(false)
  useEffect(() => {
    if (isMounted.current) {
      formik.setFieldTouched('phoneNumber', true, true)
    } else {
      isMounted.current = true
    }
  }, [countryPhoneRegex])

  const phoneNumberHandler = (event) => {
    let value = event.target.value
    if (value != '') {
      value = convertNumbersToEnglish(value)
      value = onlyDigits(value)
    }
    formik.setFieldValue('phoneNumber', value)

    if (value.length >= 2) {
      if (value[0] == 0) {
        let phoneNumberWithoutZero = value.substring(1)
        formik.setFieldValue('phoneNumber', phoneNumberWithoutZero)
      }
    }
    if (value.length >= 5) {
      if (countryId != 0) {
        let countryCodeWithoutPlus = countryCode
        let countryCodeWithPlus = countryCode
        if (countryCodeWithoutPlus.startsWith('+')) {
          countryCodeWithoutPlus = countryCodeWithoutPlus.substring(1)
        }
        if (value.startsWith(countryCodeWithoutPlus)) {
          let phoneNumberWithoutcountryCode = value.substring(countryCodeWithoutPlus.length)
          formik.setFieldValue('phoneNumber', phoneNumberWithoutcountryCode)
        }
        if (value.startsWith(countryCodeWithPlus)) {
          let phoneNumberWithoutcountryCode = value.substring(countryCodeWithPlus.length)
          formik.setFieldValue('phoneNumber', phoneNumberWithoutcountryCode)
        }
      } else {
        let phoneNumberCountryCode = value.substring(0, 5)
        let countryFound = countries.find((x) => {
          let code = phoneNumberCountryCode.substring(0, x.code.length - 1)
          let codeFromServer = x.code
          if (codeFromServer.startsWith('+')) {
            codeFromServer = codeFromServer.substring(1)
          }
          return codeFromServer == code
        })
        if (countryFound != undefined) {
          formik.setFieldValue('countryId', countryFound?.value)
          setSelectedOption(countryFound ?? countries[0])
          setCountryCode(countryFound?.code ?? countries[0].code)
          setCountryId(Number(countryFound?.value ?? countries[0].value))
          setCountryPhoneRegex(countryFound?.regex ?? countries[0].regex)
        }
      }
    }
  }

  const navigate = useNavigate()
  const [appNameId, setAppNameId] = useState('')
  const formik = useFormik({
    initialValues,
    validationSchema: registrationSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        if (countryId === 0) {
          setStatus(t('AUTH.VERIFY.COUNTRY_REQUIRED'))
          setSubmitting(false)
          setLoading(false)
          return false
        } else if (countryCode === '') {
          setStatus(t('AUTH.VERIFY.COUNTRY_CODE_REQUIRED'))
          setSubmitting(false)
          setLoading(false)
          return false
        } else if (values.phoneNumber.length != countryPhoneRegex) {
          setStatus(t('AUTH.VERIFY.PHONE_LENGTH_ERROR', {count: countryPhoneRegex}))
          setSubmitting(false)
          setLoading(false)
          return false
        } else {
          setStatus('')
        }
        const verifyPhoneNumberResult = await verifyPhoneNumber(
          countryId,
          values.phoneNumber,
          countryCode
        )
        if (verifyPhoneNumberResult.data?.isSuccess) {
          navigate({
            pathname: '/auth/register-login',
            search: searchParams.toString(),
          }, {
            state: {
              phoneNumber: values.phoneNumber,
              countryCode: countryCode,
              countryId: countryId,
              appNameId: appNameId,
              inviteCode: codeMemory,
            },
          })
          const newStartTime = Date.now()
          localStorage.setItem('startTime', newStartTime.toString())
        } else if (verifyPhoneNumberResult.data?.isSuccess == false) {
          saveAuth(undefined)
          let message = JSON.parse(verifyPhoneNumberResult.data.message)
          if (message.length >= 1) {
            let messageShow = message[0].Value.DefaultMessage
            if (verifyPhoneNumberResult.data.requestId != null) {
              messageShow =
                messageShow +
                '\n ' +
                t('AUTH.VERIFY.ERROR_CODE') +
                ' : ' +
                verifyPhoneNumberResult.data.requestId
            }
            if (verifyPhoneNumberResult.data.returnType == 2) {
              setWarningMessage(messageShow)
              setShowWarningMessage(true)
            } else if (verifyPhoneNumberResult.data.returnType == 3) {
              setErrorMessage(messageShow)
              setShowErrorMessage(true)
            }
          } else {
            let messageShow = message.Value.DefaultMessage
            if (verifyPhoneNumberResult.data.requestId != null) {
              messageShow =
                messageShow +
                '\n ' +
                t('AUTH.VERIFY.ERROR_CODE') +
                ' : ' +
                verifyPhoneNumberResult.data.requestId
            }
            if (verifyPhoneNumberResult.data.returnType == 2) {
              setWarningMessage(messageShow)
              setShowWarningMessage(true)
            } else if (verifyPhoneNumberResult.data.returnType == 3) {
              setErrorMessage(messageShow)
              setShowErrorMessage(true)
            }
          }
          setSubmitting(false)
          setLoading(false)
        } else {
          setStatus(`${t('AUTH.VERIFY.SEND_CODE_ERROR')} : \n ${verifyPhoneNumberResult}`)
          setSubmitting(false)
          setLoading(false)
        }
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus(t('AUTH.VERIFY.UNKNOWN_ERROR'))
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  useEffect(() => {
    if (currentUser?.id != '') {
      // console.log('already logined')
    }
    PasswordMeterComponent.bootstrap()
    const fetchData = async () => {
      var countriesResult = await getAllCountries()
      const countriesList: TypeCountries[] = []
      if (countriesResult.length != undefined) {
        countriesResult.forEach((element) => {
          countriesList.push({
            code: element.phone,
            label: `${element.name}`,
            name: element.name,
            icon: `https://panel.airngin.com/media/flags/${element.name.toLowerCase()}.svg`,
            value: element.id.toString(),
            regex: element.phoneRegex,
          })
        })
        setCountries(countriesList)
      } else {
        setErrorMessage(`${t('AUTH.VERIFY.COUNTRIES_FETCH_ERROR')} : \n ${countriesResult}`)
        setShowErrorMessage(true)
      }
      var appNameResult = await GetAppNameByName('IOT', 'Center')
      if (appNameResult.data?.isSuccess == true) {
        setAppNameId(appNameResult.data.data.appNameId)
      } else if (appNameResult.data?.isSuccess == false) {
        let message = JSON.parse(appNameResult.data.message)
        if (message.length >= 1) {
          if (appNameResult.data.returnType == 2) {
            setWarningMessage(message[0].Value.DefaultMessage)
            setShowWarningMessage(true)
          } else if (appNameResult.data.returnType == 3) {
            setErrorMessage(message[0].Value.DefaultMessage)
            setShowErrorMessage(true)
          }
        } else {
          if (appNameResult.data.returnType == 2) {
            setWarningMessage(message.Value.DefaultMessage)
            setShowWarningMessage(true)
          } else if (appNameResult.data.returnType == 3) {
            setErrorMessage(message.Value.DefaultMessage)
            setShowErrorMessage(true)
          }
        }
      } else {
        setErrorMessage(`${t('AUTH.VERIFY.APP_INFO_FETCH_ERROR')} : \n ${appNameResult}`)
        setShowErrorMessage(true)
      }
    }
    fetchData()

    const originalTitle = document.title
    document.title = `${originalTitle} | ${t('AUTH.REGISTER')}`
    return () => {
      document.title = originalTitle
    }
  }, [t])

  return (
    <form
      className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
      noValidate
      id='kt_login_signup_form'
      onSubmit={formik.handleSubmit}
    >
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>{t('AUTH.REGISTER')}</h1>
      </div>

      {formik.status && (
        <div className='mb-lg-15 alert alert-danger'>
          <div className='alert-text font-weight-bold'>{formik.status}</div>
        </div>
      )}

      {showErrorMessage ? (
        <div className='alert alert-danger d-flex align-items-center p-5 mb-10'>
          <span className='svg-icon svg-icon-2hx svg-icon-danger me-3'></span>
          <div className='d-flex flex-column'>
            <span>{errorMessage}</span>
          </div>
        </div>
      ) : null}
      {showWarningMessage ? (
        <div className='alert alert-warning d-flex align-items-center p-5 mb-10'>
          <span className='svg-icon svg-icon-2hx svg-icon-warning me-3'></span>
          <div className='d-flex flex-column'>
            <span>{warningMessage}</span>
          </div>
        </div>
      ) : null}

      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-dark fs-6'>{t('AUTH.COUNTRY')}</label>
        <Select
          classNamePrefix='react-select'
          {...formik.getFieldProps('countryId')}
          name='countryId'
          onChange={changeCountryHandler}
          value={selectedOption}
          isDisabled={false}
          isLoading={false}
          isClearable={false}
          isRtl={i18n.dir() === 'rtl'}
          isSearchable={true}
          className={clsx(
            'react-select-styled basic-single',
            {
              'is-invalid': formik.touched.countryId && formik.errors.countryId,
            },
            {
              'is-valid': formik.touched.countryId && !formik.errors.countryId,
            }
          )}
          options={countries.map((item) => ({
            ...item,
            label: (
              <div className='label'>
                <img src={item.icon} alt='flag' className='w-20px rounded-circle me-2' />
                <span>{item.label}</span>
                <label className='ltr-direction'>{`(${item.code})`} </label>
              </div>
            ),
          }))}
          placeholder={t('AUTH.COUNTRY')}
          defaultValue={countries[0]}
          filterOption={customFilter}
        />
      </div>

      <div className='fv-row mb-8'>
        <label className='form-label fw-bolder text-dark fs-6'>{t('AUTH.PHONE_NUMBER')}</label>
        <div className='inline-row'>
          <input
            ref={phoneNumberRef}
            placeholder={t('AUTH.PHONE_NUMBER')}
            type='text'
            autoComplete='off'
            {...formik.getFieldProps('phoneNumber')}
            onKeyUp={phoneNumberHandler}
            className={clsx(
              'form-control bg-transparent ltr-direction',
              {
                'is-invalid': formik.touched.phoneNumber && formik.errors.phoneNumber,
              },
              {
                'is-valid': formik.touched.phoneNumber && !formik.errors.phoneNumber,
              }
            )}
          />
          <input
            type='text'
            readOnly
            id='countryCode'
            value={countryCode}
            className='form-control bg-transparent ltr-direction countryCode'
          />
        </div>

        {formik.touched.phoneNumber && formik.errors.phoneNumber && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.phoneNumber}</span>
            </div>
          </div>
        )}
      </div>

      <div className='text-center'>
        <button
          type='submit'
          id='kt_sign_up_submit'
          className='btn btn-lg btn-main w-100 mb-5'
          disabled={
            formik.isSubmitting ||
            !formik.isValid ||
            countryId == 0 ||
            showErrorMessage == true ||
            showWarningMessage == true
          }
        >
          {!loading && <span className='indicator-label'>{t('AUTH.SEND_CODE')}</span>}
          {loading && (
            <span className='indicator-progress display-block'>
              {t('AUTH.PLEASE_WAIT')}{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </form>
  )
}
